// extracted by mini-css-extract-plugin
module.exports = {"chevron":"_39Wjm","up":"_3ut33"};